import { render } from "./Masthead.vue?vue&type=template&id=65b0ce5a&scoped=true"
import script from "./Masthead.vue?vue&type=script&lang=js"
export * from "./Masthead.vue?vue&type=script&lang=js"

import "./Masthead.vue?vue&type=style&index=0&id=65b0ce5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b0ce5a"]])

export default __exports__